var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEdit = function SvgEdit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M17.561 5.976a1.5 1.5 0 0 0 0-2.123L16.148 2.44a1.5 1.5 0 0 0-2.123 0l-1.437 1.437 3.541 3.543zm-5.68-1.391-9.28 9.28-.591 3.357a.664.664 0 0 0 .768.768l3.356-.588 9.278-9.28z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export default ForwardRef;